import * as S from './styles';
import Loading from '../../../components/Loading';
//icons
import {
    Package,
    CreditCard,
    Checks,
    X
} from '@phosphor-icons/react';

interface ToastConfirmSaleProps {
    error?: string;
    isOpenModalToast: boolean;
    setIsOpenModalToast: () => void;
    messagerCount: {
        count: number,
        message: string
    }
}

export default function ToastConfirmSale({
    error,
    isOpenModalToast,
    setIsOpenModalToast,
    messagerCount
}: ToastConfirmSaleProps) {

    const handleCloseModal = () => {
        setIsOpenModalToast();
    }

    if (!isOpenModalToast) return null;
    return (
        <S.Container>
            <S.Content>
                <S.Header>
                    <S.Button onClick={handleCloseModal}>
                        <X size={16} />
                    </S.Button>

                    <S.ContentHeader>
                        <S.Icon>
                            {
                                error ?
                                    <CreditCard size={32} color="red" /> :
                                    <Package size={32} />
                            }
                        </S.Icon>

                        <S.Text className='title'>
                            {error ? "Erro ao finalizar" : messagerCount.message}
                        </S.Text>
                        {
                            error &&
                            <S.Text className='subtitle'>
                                {error}
                            </S.Text>
                        }

                    </S.ContentHeader>
                </S.Header>

                <S.ContentProgress>
                    <S.ContentLine>
                        <S.Text>Progresso</S.Text>
                        <S.Text>{messagerCount.count}/4</S.Text>
                    </S.ContentLine>
                    <S.BarProgress>
                        <S.BarProgress style={{ width: `${(messagerCount.count / 4) * 100}%` }} className='barfill' />
                    </S.BarProgress>
                </S.ContentProgress>

                {!error && <Loading color='green' />}

                <S.ListItem>
                    {messagerCount.message}
                    <Checks size={14} />
                </S.ListItem>
            </S.Content>
        </S.Container>
    );
}